import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Solar_Power from "./solar-power/Solar_Power";
import Power_Progress from "./power-progress/Power_Progress";
import Our_Presence from "./our-presence/Our_Presence";
import Free_Consultation from "./free-consultation/Free_Consultation";
import Consultation_Banner from "./consultation-banner/Consultation_Banner";
import Why_Choose_Us from "../about-us/why_choose_us/Why_Choose_Us";
import Trusted_Communities from "./trusted-communities/Trusted_Communities";
import What_Customer_Say from "./what-customer-say/What_Customer_Say";
import Solar_Insights from "./solar-insights/Solar_Insights";

function Home() {
  return (
    <>
      <Banner />
      <Solar_Power />
      <Power_Progress />
      <Our_Presence />
      <Free_Consultation />
      <Solar_Insights />
      <Consultation_Banner />
      <Why_Choose_Us />
      <Trusted_Communities />
      <What_Customer_Say />
    </>
  );
}

export default Home;
